// Note: Colors are now managed by the unified ColorManager system
// Import { globalColorManager } from '../../utils/ColorManager' to use colors

// Check if point already exists in any vehicle path
export const isPointInAnyPath = (pointId, vehiclePaths, startId) => {
  // Start point can exist in multiple paths
  if (pointId === startId) return false;
  
  return vehiclePaths.some(vehicle => 
    vehicle.path.some(point => point && point.id === pointId)
  );
};

// Add start point to vehicle path end if needed
export const addStartPointToPathEnd = (vehiclePaths, startId, locations) => {
  // First find the start point location object
  const startPoint = locations.find(loc => loc.id === startId);
  if (!startPoint) {
    return vehiclePaths; // If start point not found, return original paths
  }
  
  const updatedPaths = vehiclePaths.map(vehicle => {
    // If path is empty or has only one point, no changes needed
    if (!vehicle.path || vehicle.path.length <= 1) {
      return vehicle;
    }
    
    const path = [...vehicle.path];
    const lastPoint = path[path.length - 1];
    
    // If last point is not start point and path has start point, add start point to path end
    if (lastPoint && lastPoint.id !== startId) {
      return { ...vehicle, path: [...path, startPoint] };
    }
    
    return vehicle;
  });
  
  return updatedPaths;
}; 